define(
//begin v1.x content
({
	loadingState: "Ielādē...",
	errorState: "Diemžēl radās kļūda"
})
//end v1.x content
);
